import React, { useState } from 'react';
import {Button, Col, Layout, Row, Carousel } from 'antd';
import { SendOutlined } from '@ant-design/icons';
import HeaderFile from './Layout/HeaderFile';
import FooterFile from './Layout/FooterFile';
import { useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import SmoothScrollProvider from './Layout/SmoothScrollProvider';
import LottieComponent from './Layout/LottieAnimation';
import BlurText from './Layout/BlurText';
import { ParallaxBanner } from 'react-scroll-parallax';


const { Header, Content, Footer } = Layout;

const Home = () => {

  const [position] = useState('end');
  const [isMobile, setIsMobile] = useState(window.innerWidth);
  const navigate = useNavigate();
  
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 770); // Set breakpoint for mobile
    };

    handleResize(); // Set initial state
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const desktopStyles = {
    backgroundImage: "url('/about-bg.png')",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    width: "100%",
    padding: "0 5% 5%",
    display: "none",
  };

  const mobileStyles = {
    backgroundImage: "url('/about-bg.png')",
    backgroundSize: "cover",
    backgroundPosition: "bottom center",
    backgroundRepeat: "no-repeat",
    width: "100%",
    padding: "0 5% 5%",
    display: "none",
  };



  return (
    // Layout used to maintain the layout of the page in antd

    <Layout>
      <SmoothScrollProvider/>

      <Header className='header-style' >
        {/* Importing from the another component */}
        <HeaderFile/>
      </Header>

      <Content>
       

       <div className='background-frame'>
  <ParallaxBanner
    className='parallax-style parallax-bg-h '
    layers={[
      {
        speed: -10,
        children: (
          <iframe
            src="https://player.vimeo.com/video/1136787987?h=6ec959a725&autoplay=1&loop=1&muted=1&background=1"
            title="Vimeo Player"            
            allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
            allowFullScreen            
          />
        ),
      },

      {
        speed: -25,
        children: (
          <div className="image-content">
            

            
          </div>
        ),
      },
    ]}
  />
</div>


        <Row justify="center" className="abtwrp" align="middle" style={{padding:"0 5%"}}>
            <Col xs={{ span: 24, order: 1 }}
  md={{ span: 12, order: 1 }}
  className="sample-content-col abttext">
              <p className="sample-content"> <span className='qouteicn'>“</span>We're Mouna and Shyam. We live to motorbike, wander, get lost occasionally, and collect stories everywhere we go alongside a full time 9-5 career. <span className='spanblock'>This is our corner of the internet, dedicated to meaningful travel and authentic experiences.</span> </p>
           <p className="sample-contenttw">  You Don't Have to Quit Your Job to Travel.<span> We didn't!</span> </p>
               <Button
              className="top-img-button"
        iconPosition={position}
        onClick={() => navigate("/about")}
        ghost
        icon={<SendOutlined />}
        style={{
          height: "50px",
          padding: "0 28px",
          borderRadius: "50px",
          fontSize: "16px",
          fontWeight: "600",
        }}
            >
              Know Us
            </Button>
           
            </Col>
            <Col xs={{ span: 24, order: 2 }}
  md={{ span: 10, order: 2 }}
  className="abtimg"
  style={{ display: "flex", justifyContent: "center" }}>
            <img
                src="/about-right.webp"
                alt="Logo"
                style={{ }}
              />
            </Col>
            
        </Row>


        {/* Adventure CTA Section */}

<div className="adventure-section">
  <Row
    justify="center"
    align="middle"
    gutter={[10]}
    style={{ maxWidth: "1400px", margin: "0 auto" }}
  >

    {/* LEFT IMAGE AREA */}
    <Col xs={24} md={14}>
    {!isMobile && (
      <div className="adventure-images">

        <img
          src="/trips_events.webp"
          alt="Adventure"
          className="main-adventure-img"
        />        

      </div>
    )}
    </Col>

    {/* RIGHT CONTENT */}
    <Col xs={24} md={10}>
      <div className="adventure-content">
<div
    style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      maxWidth: "700px",
    }}
  >
    <img
      src="/wave.png"
      alt="Wave icon"
      style={{
        width: "55px",
        marginBottom: "1rem",
    
      }}
    />
     <h2
      className="headings" > Come Travel With Us  </h2>
          
    {isMobile && (
  <div className="adventure-images">

        <img
          src="/trips_events.webp"
          alt="Adventure"
          className="main-adventure-img"
        style={{
        marginBottom: "1rem",
    
      }} />        

      </div>
    )}
    <p className='hmsubhead'>  We organize curated, community-first group trips for
          passionate travelers and riders. Stop scrolling your
          feed and come make <span className='sample-contenttw'> real memories</span> with us.</p>
  </div>        

        <Button
      className="top-img-button"
      onClick={() =>
        window.location.href =
          "https://blog.rucksackdiaries.com/trips-events/"
      }
      style={{
        height: "52px",
        padding: "0 28px",
        borderRadius: "50px",
        fontSize: "16px",
        fontWeight: "600",
        marginTop:"10px",
      }}
    >
      Take me to Trips & Events
    </Button>

      </div>
    </Col>

  </Row>
</div>



        {/* Blog of mopbile and web */}
        {isMobile && (
            <div className="blog-bag">
              
               <div className='blg-headwrp'>
                 <div
    style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      maxWidth: "700px",
    }}
  >
    
    <img
      src="/wave.png"
      alt="Wave icon"
      style={{
        width: "55px",
    
      }}
    />

    <h2
      className="headings" > Blogs</h2>
    <p className='hmsubhead'> Looking for inspiration for your next journey? Let our blogs guide you!</p>
  </div>
                
               </div>
              
              <Carousel infinite={true} autoplay={{ dotDuration: true }} autoplaySpeed={5000}>
              <div>
              <Row justify="space-evenly" align="middle" style={{marginTop:"0rem"}}>
              <Col span={10} className="blog-style">
                <img
                  src="/blog1.png"
                  alt="Logo"
                  style={{ width: "99%"}}
                />
                <a href="https://blog.rucksackdiaries.com/blogs/?brx_guomlo=incredible-india"  rel="noopener noreferrer"><p className="blog-text">Incredible India</p></a>
                 <a className='cardbtn' href="https://blog.rucksackdiaries.com/blogs/?brx_guomlo=incredible-india"  rel="noopener noreferrer">
                <p>ReadMore <SendOutlined style={{color:"#FFA321"}}/></p>
                </a>
              </Col>

              <Col span={10} className="blog-style">
                <img  
                  src="/blog2.png"
                  alt="Logo"
                  style={{ width: "99%"}}
                />
                  <a href="https://blog.rucksackdiaries.com/blogs/?brx_guomlo=beyond-borders"  rel="noopener noreferrer"><p className="blog-text">Beyond Borders</p></a>
                  <a className='cardbtn' href="https://blog.rucksackdiaries.com/blogs/?brx_guomlo=beyond-borders"  rel="noopener noreferrer">
                <p>ReadMore <SendOutlined style={{color:"#FFA321"}}/></p>
                </a>

              </Col>
              </Row>
              </div>
              <div>
              <Row justify="space-evenly" align="middle" style={{marginTop:"0rem"}}>
              <Col span={10} className="blog-style">
                <img
                  src="/blog3.png"
                  alt="Logo"
                  style={{ width: "99%"}}
                />
               <a href="https://blog.rucksackdiaries.com/blogs/?brx_guomlo=on-two-wheels"  rel="noopener noreferrer"> <p className="blog-text">On Two Wheels</p> </a>
                <a className='cardbtn' href="https://blog.rucksackdiaries.com/blogs/?brx_guomlo=on-two-wheels"  rel="noopener noreferrer">
                 <p>ReadMore <SendOutlined style={{color:"#FFA321"}}/></p>
                </a>
              </Col>

              <Col span={10} className="blog-style">
                <img
                  src="/milentalescover.png"
                  alt="Logo"
                  style={{ width: "99%"}}
                />
                  <a href="https://blog.rucksackdiaries.com/blogs/?brx_guomlo=miles-n-tales"  rel="noopener noreferrer"><p className="blog-text">Miles and Tales</p></a> 
                <a className='cardbtn' href="https://blog.rucksackdiaries.com/blogs/?brx_guomlo=miles-n-tales"  rel="noopener noreferrer">
                <p>ReadMore <SendOutlined style={{color:"#FFA321"}}/></p>
                </a>

              </Col>
              </Row>
              </div>
              </Carousel>
            </div>
        )}

        {!isMobile && (
        <div
          style={{
            backgroundImage: "url('/contentBG.png')",
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            width: "100%",
            height: "auto",
            padding: "2% 5% 5%"
          }}
        >

            <div
  style={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "2rem",
    padding: "0rem 0 0",
    flexWrap: "wrap",
  }}
>
  
  {/* LEFT CONTENT */}
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      maxWidth: "700px",
    }}
  >
    
    <img
      src="/wave.png"
      alt="Wave icon"
      style={{
        width: "55px",
        marginBottom: "1rem",
      }}
    />

    <h2
      className="headings" > Blogs</h2>
    <p className='hmsubhead'> Looking for inspiration for your next journey? Let our blogs guide you!</p>
  </div>
              <div style={{position: "absolute", right: "0"}}>
              <LottieComponent/>

              </div>

              </div>

            <Row justify="center"  align="middle"  gutter={[24, 24]}  style={{ marginTop: "1rem" }}>
              <Col span={6} className="blog-style">
                <a href="https://blog.rucksackdiaries.com/blogs/?brx_guomlo=incredible-india"  rel="noopener noreferrer">
                <img
                  src="/blog1.png"
                  alt="Logo"
                  style={{ width: "100%"}}
                /></a>
                 <a href="https://blog.rucksackdiaries.com/blogs/?brx_guomlo=incredible-india"  rel="noopener noreferrer"><p className="blog-text">Incredible India
                </p></a>
                <a className='cardbtn' href="https://blog.rucksackdiaries.com/blogs/?brx_guomlo=incredible-india"  rel="noopener noreferrer">
                <p>ReadMore <SendOutlined style={{color:"#FFA321"}}/></p>
                </a>
              </Col>

              <Col span={6} className="blog-style">
                <a href="https://blog.rucksackdiaries.com/blogs/?brx_guomlo=beyond-borders"  rel="noopener noreferrer">
                <img
                  src="/blog2.png"
                  alt="Logo"
                  style={{ width: "100%"}}
                /></a>
                 <a href="https://blog.rucksackdiaries.com/blogs/?brx_guomlo=beyond-borders"  rel="noopener noreferrer"> <p className="blog-text">Beyond
                  Borders</p></a>
                <a className='cardbtn' href="https://blog.rucksackdiaries.com/blogs/?brx_guomlo=beyond-borders"  rel="noopener noreferrer">
                 <p>ReadMore <SendOutlined style={{color:"#FFA321"}}/></p>
                </a>

              </Col>

              <Col span={6} className="blog-style">
              <a href="https://blog.rucksackdiaries.com/blogs/?brx_guomlo=on-two-wheels"  rel="noopener noreferrer">
                <img
                  src="/blog3.png"
                  alt="Logo"
                  style={{ width: "100%"}}
                /></a>
               <a href="https://blog.rucksackdiaries.com/blogs/?brx_guomlo=on-two-wheels"  rel="noopener noreferrer"> <p className="blog-text">On Two
                Wheels</p></a>
                <a className='cardbtn' href="https://blog.rucksackdiaries.com/blogs/?brx_guomlo=on-two-wheels"  rel="noopener noreferrer">
                <p>ReadMore <SendOutlined style={{color:"#FFA321"}}/></p>
                  </a>
              </Col>

              <Col span={6} className="blog-style">
             <a href="https://blog.rucksackdiaries.com/blogs/?brx_guomlo=miles-n-tales"  rel="noopener noreferrer">
                <img
                  src="/milentalescover.png"
                  alt="Logo"
                  style={{ width: "100%"}}
                /></a>
              <a href="https://blog.rucksackdiaries.com/blogs/?brx_guomlo=miles-n-tales"  rel="noopener noreferrer"> <p className="blog-text">Miles n
                Tales</p></a> 
                <a className='cardbtn' href="https://blog.rucksackdiaries.com/blogs/?brx_guomlo=miles-n-tales"  rel="noopener noreferrer">
                <p>ReadMore <SendOutlined style={{color:"#FFA321"}}/></p>
                </a>

              </Col>
            </Row>
        </div>
        )}
      
    


        <div className='shop-BG'>
        <div
  style={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "2rem",
    padding: "0rem 0 0",
    flexWrap: "wrap",
  }}
>
  
  {/* LEFT CONTENT */}
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      maxWidth: "700px",
    }}
  >
    
    <img
      src="/wave.png"
      alt="Wave icon"
      style={{
        width: "55px",
   
      }}
    />

    <h2
      className="headings" > Shop</h2>
    <p className='hmsubhead'>Browse our guides, gear, and goodies for your next adventure.</p>
  </div>

   <div className="compus-icon">
<img
                  src="/compus.png"
                  alt="Logo"
                  style={{ width: "8rem", marginTop:"2rem"}}
                />
  </div>
  </div>
  

                            <Row
                  justify="center"
                  align="middle"
                  gutter={[24, 24]}
                  style={{ marginTop: "1rem" }}
                >
              <Col xs={24} md={12} className="blog-style">
              <div className='shopCrd'>
                <a href="https://blog.rucksackdiaries.com/shop/"  rel="noopener noreferrer"> 
                <img
                  src="/digitalproduct.webp"
                  alt="Logo"
                  style={{ width: "100%", display: "block" }}
                />
                </a>

                <a className='shop-style' href="https://blog.rucksackdiaries.com/shop/"  rel="noopener noreferrer"> 
                  <div>
                  Digital products
                  <SendOutlined style={{ color: "#FFFFFF", marginLeft: "5px" }} />
                </div></a>
              </div>

              </Col>

              <Col xs={24} md={12} className="blog-style">
              <div className='shopCrd'>
                <a href="https://www.instagram.com/miles.n.tales/"  rel="noopener noreferrer"> 
                <img
                  src="/getquirky.webp"
                  alt="Logo"
                  style={{ width: "100%", display: "block" }}
                />
                </a>
                  <a className='shop-style' href="https://www.instagram.com/miles.n.tales/"  rel="noopener noreferrer"> 
                <div>
                  Get quirky with our Merchandise
                  <SendOutlined style={{ color: "#FFFFFF", marginLeft: "5px" }} />
                </div>
                </a>
              </div>
              </Col>
            </Row>
            
            
        </div>
      

      
       {/* About US */}
        <div
          style={isMobile ? mobileStyles : desktopStyles}
        >

        <Row justify="center" className="abtbtm-wrp" align="middle" >
            <Col span={14} className="sample-content-col abtbtm-grdone">
            <img
                src="/wave.png"
                alt="Logo"
                style={{ width: isMobile ? "20%" : "10%" }}
              />
              <h3 className='headings'>
              About Us!
              </h3>
              <p className="about-home-content">Mouna Nanaiah, is an Indian origin Travel Creator, Motorcyclist, and Entrepreneur hailing from the Silicon City of Bangalore. She is a multifaceted individual known for chasing multiple passions with purpose. Shyam, her partner in crime, is also an avid and seasoned motorcyclist. Being full time IT professionals and passionate about bikes, the duo lives for the thrill of the open road.
Together they have ridden over 1 lakh+ kilometers across 24 states in India, riding through mountains, deserts, coastlines, everything in between and beyond borders. </p><p className="about-home-content">Mouna brings together her love for travel, storytelling, and meaningful conversations. Shyam brings logic to the love of motorcycles. Through their adventures on two wheels and their creative pursuits, they  inspire others to explore boldly, live curiously, and build lives driven by passion and authenticity. </p><p className="about-home-content">Mouna shares her travel experiences with her social media community of over 3 lakh subscribers and helps them via travel tips, itineraries and plans.</p>    
              <Button
              className="top-img-button"
              iconPosition={position}
              onClick={()=>navigate('/about')}
              ghost
              icon={<SendOutlined />}
            >
              Know Us
            </Button>
            </Col>
            <Col span={10} className="abtbtm-grdtwo" style={{display:"flex", justifyContent:"center"}}>
            <img
                src="/aboutus.png"
                alt="Logo"
                style={{ width: "60%", marginTop:"20px"}}
              />
            </Col>
        </Row>
        </div>

      </Content>

      <Footer style={{ position: 'relative', overflow: 'hidden' }}>
        <FooterFile/>
      </Footer>

    </Layout>
  )
}

export default Home




